// extracted by mini-css-extract-plugin
export default {"wrapper":"Language_wrapper__KVqzw","item":"Language_item__Ljm+d","currenLang":"Language_currenLang__q+Ekg","modal":"Language_modal__eOA-D","active":"Language_active__HM7OJ"};